import occupymars from './occupymars'

const config = [
    {
        name: 'Occupy Mars',
        slug: 'occupymars',
        config: occupymars,
    },
]

export default config
